import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class SwitchTV extends PureComponent {
    static propTypes = {
        channelChange: PropTypes.func,
        phtvVideoInfo: PropTypes.array,
    };

    state = {
        activeIndex: 0,
    };

    channelNameHanle = value => {
        const { channelChange } = this.props;

        this.setState({
            activeIndex: value,
        });
        channelChange(value);
    };

    render() {
        const { phtvVideoInfo } = this.props;
        // const { activeIndex } = this.state;

        return (
            <div className={styles.switchTV}>
                {phtvVideoInfo.slice(0, 2).map((item, index) => {
                    return (
                        <a
                            key={index}
                            target="_blank"
                            href={phtvVideoInfo[index]?.url}
                            className={`${styles.switchTvItem}`}>
                            <img className={styles.switchTvIcon} src={item.icon} alt={item.titleZH} />
                            <span className={styles.switchTvName}>{item.titleZH}</span>
                        </a>
                    );
                })}
            </div>
        );
    }
}

export default SwitchTV;
